import {
    FETCH_Lang_REQUEST,
} from "./type";
import axios from "axios";
import { API_ENDPOINT } from '../../AppConfig';
import { hideLoading } from 'react-redux-loading-bar';

export function ChangeLangauge(lang,token) {
  return (dispatch, getState) => {
    saveToLocalStorage('Language', lang);
    const Submitdata = new FormData();
    Submitdata.append('language', lang)
    Submitdata.append('userId', localStorage.getItem("id"))
    let uri = `${API_ENDPOINT}/user/updateInfo`;
    axios.put(uri,Submitdata,{
      headers: {
        Authorization:`Bearer ${token}`
      }
    })
        .then(response => {
            dispatch({ type: FETCH_Lang_REQUEST , payload:lang });
            dispatch(hideLoading());
        }).catch(error => {
            dispatch(hideLoading());
        })
}
    
  }
  export function ChangeVisitorLangauge(lang,token) {
    return (dispatch, getState) => {
      saveToLocalStorage('Language', lang);
              dispatch({ type: FETCH_Lang_REQUEST , payload:lang });
              dispatch(hideLoading());
  }
      
    }
  
  export function saveToLocalStorage(key, value){
    localStorage.setItem(key, value);
  }